"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6483],{

/***/ 68118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Slider_Slider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Slider/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: 0;\n  position: absolute;\n  left: 14px;\n  width: calc(100% - 30px);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: 0;\n  font-size: 12px;\n  left: ",
        ";\n  position: absolute;\n  text-align: center;\n  min-width: 24px; // Slider thumb size\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url(",
        ") no-repeat;\n  height: 32px;\n  filter: ",
        ";\n  position: absolute;\n  width: 15px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 14px;\n  width: calc(100% - 14px);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: ",
        ";\n  height: 10px;\n  position: relative;\n  ::-webkit-slider-thumb {\n    ",
        "\n  }\n  ::-moz-range-thumb {\n    ",
        "\n  }\n  ::-ms-thumb {\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: 2px;\n  position: absolute;\n  top: 18px;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  filter: ",
        ";\n  height: 2px;\n  position: absolute;\n  top: 18px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var getCursorStyle = function getCursorStyle(param) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    return disabled ? "not-allowed" : "cursor";
};
var bunnyHeadMax = '"data:image/svg+xml;base64,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"';
var bunnyHeadMain = '"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDEwQzIwIDExLjgxNDIgMTkuNTUzIDEzLjQ4NzQgMTguNjU4OSAxNS4wMTk1QzE3Ljc2NDggMTYuNTUxNiAxNi41NTE2IDE3Ljc2NDggMTUuMDE5NSAxOC42NTg5QzEzLjQ4NzQgMTkuNTUzIDExLjgxNDIgMjAgMTAgMjBDOC4xODU3NiAyMCA2LjUxMjU5IDE5LjU1MyA0Ljk4MDQ3IDE4LjY1ODlDMy40NDgzNSAxNy43NjQ4IDIuMjM1MjQgMTYuNTUxNiAxLjM0MTE1IDE1LjAxOTVDMC40NDcwNDkgMTMuNDg3NCAwIDExLjgxNDIgMCAxMEMwIDguMTg1NzYgMC40NDcwNDkgNi41MTI1OSAxLjM0MTE1IDQuOTgwNDdDMi4yMzUyNCAzLjQ0ODM1IDMuNDQ4MzUgMi4yMzUyNCA0Ljk4MDQ3IDEuMzQxMTVDNi41MTI1OSAwLjQ0NzA0OSA4LjE4NTc2IDAgMTAgMEMxMS44MTQyIDAgMTMuNDg3NCAwLjQ0NzA0OSAxNS4wMTk1IDEuMzQxMTVDMTYuNTUxNiAyLjIzNTI0IDE3Ljc2NDggMy40NDgzNSAxOC42NTg5IDQuOTgwNDdDMTkuNTUzIDYuNTEyNTkgMjAgOC4xODU3NiAyMCAxMFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8zODBfNikiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8zODBfNiIgeDE9IjUuMDc1NzYiIHkxPSItMi45MTE5OWUtMDgiIHgyPSIxNi40NzczIiB5Mj0iMjAiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzk0NjVGRiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5NDY1RkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K"';
var bunnyButt = "\"data:image/svg+xml,%3Csvg width='15' height='32' viewBox='0 0 15 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.58803 20.8649C7.72935 21.3629 8.02539 24.0334 8.76388 26.7895C9.50238 29.5456 10.5812 32.0062 12.4399 31.5082C14.2986 31.0102 15.2334 28.0099 14.4949 25.2538C13.7564 22.4978 11.4467 20.3669 9.58803 20.8649Z' fill='%230098A1'/%3E%3Cpath d='M1 24.4516C1 20.8885 3.88849 18 7.45161 18H15V28H4.54839C2.58867 28 1 26.4113 1 24.4516Z' fill='%231FC7D4'/%3E%3Cpath d='M6.11115 17.2246C6.79693 18.4124 5.77784 19.3343 4.52793 20.0559C3.27802 20.7776 1.97011 21.1992 1.28433 20.0114C0.598546 18.8236 1.1635 17.1151 2.41341 16.3935C3.66332 15.6718 5.42537 16.0368 6.11115 17.2246Z' fill='%2353DEE9'/%3E%3Cpath d='M1.64665 23.6601C0.285995 25.0207 1.87759 27.1854 3.89519 29.203C5.91279 31.2206 8.07743 32.8122 9.43808 31.4515C10.7987 30.0909 10.1082 27.0252 8.09058 25.0076C6.07298 22.99 3.0073 22.2994 1.64665 23.6601Z' fill='%231FC7D4'/%3E%3C/svg%3E\"";
var getBaseThumbStyles = function getBaseThumbStyles(param) {
    var isMax = param.isMax, disabled = param.disabled;
    return "\n  -webkit-appearance: none;\n  background-image: url(".concat(bunnyHeadMain, ");\n  background-color: transparent;\n  box-shadow: none;\n  border: 0;\n  cursor: ").concat(getCursorStyle, ";\n  width: 20px;\n  height: 20px;\n  filter: ").concat(disabled ? "grayscale(100%)" : "none", ";\n  transform: translate(-2px, +13px);\n  transition: 200ms transform;\n");
};
var SliderLabelContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-58aeb5c4-0"
}).withConfig({
    componentId: "sc-8b8ed089-0"
})(_templateObject());
var SliderLabel = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-58aeb5c4-1"
}).withConfig({
    componentId: "sc-8b8ed089-1"
})(_templateObject1(), function(param) {
    var progress = param.progress;
    return progress;
});
var BunnyButt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-58aeb5c4-2"
}).withConfig({
    componentId: "sc-8b8ed089-2"
})(_templateObject2(), bunnyButt, function(param) {
    var disabled = param.disabled;
    return disabled ? "grayscale(100%)" : "none";
});
var BunnySlider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-58aeb5c4-3"
}).withConfig({
    componentId: "sc-8b8ed089-3"
})(_templateObject3());
var StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-58aeb5c4-4"
}).withConfig({
    componentId: "sc-8b8ed089-4"
})(_templateObject4(), getCursorStyle, getBaseThumbStyles, getBaseThumbStyles, getBaseThumbStyles);
var BarBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-58aeb5c4-5"
}).withConfig({
    componentId: "sc-8b8ed089-5"
})(_templateObject5(), function(param) {
    var theme = param.theme, disabled = param.disabled;
    return theme.colors[disabled ? "textDisabled" : "inputSecondary"];
});
var BarProgress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-58aeb5c4-6"
}).withConfig({
    componentId: "sc-8b8ed089-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.alienPurple;
}, function(param) {
    var disabled = param.disabled;
    return disabled ? "grayscale(100%)" : "none";
});

;// CONCATENATED MODULE: ./packages/uikit/src/components/Slider/Slider.tsx







var Slider = function Slider(_param) {
    var name = _param.name, min = _param.min, max = _param.max, value = _param.value, onValueChanged = _param.onValueChanged, valueLabel = _param.valueLabel, _step = _param.step, step = _step === void 0 ? "any" : _step, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "min",
        "max",
        "value",
        "onValueChanged",
        "valueLabel",
        "step",
        "disabled"
    ]);
    var handleChange = (0,react.useCallback)(function(param) {
        var target = param.target;
        onValueChanged(parseFloat(target.value));
    }, [
        onValueChanged
    ]);
    var progressPercentage = value / max * 100;
    var isMax = value === max;
    var progressWidth;
    if (progressPercentage <= 10) {
        progressWidth = "".concat(progressPercentage + 0.5, "%");
    } else if (progressPercentage >= 90) {
        progressWidth = "".concat(progressPercentage - 4, "%");
    } else if (progressPercentage >= 60) {
        progressWidth = "".concat(progressPercentage - 2.5, "%");
    } else {
        progressWidth = "".concat(progressPercentage, "%");
    }
    var labelProgress = isMax ? "calc(100% - 12px)" : "".concat(progressPercentage, "%");
    var displayValueLabel = isMax ? "MAX" : valueLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        position: "relative",
        height: "48px"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BunnySlider, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BarBackground, {
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BarProgress, {
                        style: {
                            width: progressWidth
                        },
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                        name: name,
                        type: "range",
                        min: min,
                        max: max,
                        value: value,
                        step: step,
                        onChange: handleChange,
                        isMax: isMax,
                        disabled: disabled
                    })
                ]
            }),
            valueLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderLabelContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderLabel, {
                    progress: labelProgress,
                    children: displayValueLabel
                })
            })
        ]
    }));
};
/* harmony default export */ var Slider_Slider = (Slider);


/***/ }),

/***/ 25099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ZapCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92052);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  place-content: center;\n  // background: ",
        ";\n  border-radius: 8px 0px 0px 8px;\n  border: 1px solid ",
        ";\n  border-right: none;\n  width: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ZapCheckBoxWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-7c7745e4-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var ZapCheckbox = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ZapCheckBoxWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            scale: "sm"
        }, props))
    });
};


/***/ }),

/***/ 14622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: none;\n  cursor: pointer;\n  color: ",
        ";\n  font-weight: 500;\n\n  :hover {\n    text-decoration: underline;\n  }\n\n  :focus {\n    outline: none;\n    text-decoration: underline;\n  }\n\n  :active {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledInternalLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)("a").withConfig({
    componentId: "sc-ce36bfda-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var InternalLink = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledInternalLink, {
            children: children
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InternalLink);


/***/ }),

/***/ 63580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebouncedChangeHandler; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Easy way to debounce the handling of a rapidly changing value, e.g. a changing slider input
 * @param value value that is rapidly changing
 * @param onChange change handler that should receive the debounced updates to the value
 * @param debouncedMs how long we should wait for changes to be applied
 */ function useDebouncedChangeHandler(value, onChange) {
    var debouncedMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        return value;
    }), inner = ref[0], setInner = ref[1];
    var timer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var onChangeInner = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(newValue) {
        setInner(newValue);
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(function() {
            onChange(newValue);
            timer.current = undefined;
        }, debouncedMs);
    }, [
        debouncedMs,
        onChange
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = undefined;
        }
        setInner(value);
    }, [
        value
    ]);
    return [
        inner,
        onChangeInner
    ];
}


/***/ }),

/***/ 54146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getLPSymbol; }
/* harmony export */ });
var getLPSymbol = function(token0Symbol, token1Symbol) {
    if (token0Symbol === "WBNB") {
        return "BNB-".concat(token1Symbol, " LP");
    }
    if (token0Symbol === "WETH") {
        return "ETH-".concat(token1Symbol, " LP");
    }
    if (token1Symbol === "WBNB") {
        return "".concat(token0Symbol, "-BNB LP");
    }
    if (token1Symbol === "WETH") {
        return "".concat(token0Symbol, "-ETH LP");
    }
    return "".concat(token0Symbol, "-").concat(token1Symbol, " LP");
};


/***/ }),

/***/ 81135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ZapErrorMessages; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19237);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44147);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93364);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52775);




var ZapErrorMessages = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var isSingleToken = param.isSingleToken, zapMode = param.zapMode, toggleZapMode = param.toggleZapMode, onModalDismiss = param.onModalDismiss;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var toastInfo = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* .useToast */ .p)().toastInfo;
    var handleCloseButton = function() {
        onModalDismiss();
        if (zapMode) {
            toggleZapMode(!zapMode);
            toastInfo(t("Info"), t("Temporarily disabled Zap"));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        margin: "auto",
        width: [
            "100%",
            "100%",
            "380px"
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
            variant: "warning",
            mb: "16px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* .MessageText */ .YI, {
                        bold: true,
                        children: t("Currently using Zap for liquidity provisions.")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* .MessageText */ .YI, {
                        small: true,
                        children: [
                            isSingleToken ? t("Zap does NOT support tokens with fees on transfers. If you experience any issues, click") : t("Zap does NOT support tokens with fees on transfers. Please choose ’Don't convert’ and retry. If you experience any further issues, click"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                p: "0 4px",
                                scale: "sm",
                                variant: "text",
                                height: "auto",
                                onClick: handleCloseButton,
                                children: t("here")
                            }),
                            t("to disable Zap temporarily.")
                        ]
                    })
                ]
            })
        })
    });
});


/***/ }),

/***/ 46483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RemoveLiquidity; },
/* harmony export */   "m": function() { return /* binding */ StyledPercButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(19521);
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(16441);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82125);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(89663);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(19237);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(88896);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(21812);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(70257);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(68118);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(45203);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(92052);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(44147);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(96484);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(94998);
/* harmony import */ var _pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29315);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(2593);
/* harmony import */ var utils_calls__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56946);
/* harmony import */ var utils_getLpSymbol__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(54146);
/* harmony import */ var hooks_useNativeCurrency__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19915);
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8414);
/* harmony import */ var components_CurrencyInputPanel_ZapCheckbox__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25099);
/* harmony import */ var components_CommitButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52036);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52775);
/* harmony import */ var state_swap_hooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47455);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(56974);
/* harmony import */ var utils_transactionErrorToUserReadableMessage__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(78809);
/* harmony import */ var _components_Layout_Column__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(941);
/* harmony import */ var _components_CurrencyInputPanel__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(53258);
/* harmony import */ var _components_PositionCard__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26688);
/* harmony import */ var _components_App__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(88254);
/* harmony import */ var _components_Layout_Row__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(30445);
/* harmony import */ var _components_ConnectWalletButton__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(72409);
/* harmony import */ var _components_Card__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(95934);
/* harmony import */ var _components_Logo__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(19259);
/* harmony import */ var _hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(97477);
/* harmony import */ var _hooks_useContract__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(93146);
/* harmony import */ var _hooks_useTransactionDeadline__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(25490);
/* harmony import */ var _state_transactions_hooks__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(56906);
/* harmony import */ var _components_Links__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(14622);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(97119);
/* harmony import */ var _utils_exchange__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(17937);
/* harmony import */ var _utils_currencyId__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(29159);
/* harmony import */ var _hooks_useDebouncedChangeHandler__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(63580);
/* harmony import */ var _hooks_useApproveCallback__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(36585);
/* harmony import */ var _components_Loader_Dots__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(32519);
/* harmony import */ var _state_burn_hooks__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(92015);
/* harmony import */ var _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(54820);
/* harmony import */ var _state_user_hooks__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(921);
/* harmony import */ var _Page__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(26118);
/* harmony import */ var _Swap_components_ConfirmRemoveLiquidityModal__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(95549);
/* harmony import */ var _utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(59604);
/* harmony import */ var _components_SearchModal_types__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(93156);
/* harmony import */ var views_Swap_components_AdvancedSwapDetails__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(3252);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 16px;\n  padding: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 64px;\n  height: 32px;\n  border-radius: 100px;\n  border: solid 1px ",
        ";\n  padding: 10px 14px;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 100%;\n  background: transparent;\n  outline: none;\n  box-shadow: none;\n  letter-spacing: -0.42px; \n  font-family: 'Syncopate', sans-serif;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 32px;\n  padding: 11px 14px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}














































var BorderCard = styled_components__WEBPACK_IMPORTED_MODULE_40__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-cf02b5a5-0"
})(_templateObject());
var StyledPercButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cf02b5a5-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var StyledIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cf02b5a5-2"
})(_templateObject2());
var zapSupportedChainId = [
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .ChainId.BASE_MAINNET */ .a_.BASE_MAINNET,
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .ChainId.BASE_TESTNET */ .a_.BASE_TESTNET
];
function RemoveLiquidity(param) {
    var currencyA = param.currencyA, currencyB = param.currencyB, currencyIdA = param.currencyIdA, currencyIdB = param.currencyIdB;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var native = (0,hooks_useNativeCurrency__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var ref13 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z)((0,_state_user_hooks__WEBPACK_IMPORTED_MODULE_34__/* .useZapModeManager */ .$f)(), 1), zapMode = ref13[0];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), temporarilyZapMode = ref14[0], setTemporarilyZapMode = ref14[1];
    var ref15 = (0,_hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(), account = ref15.account, chainId = ref15.chainId, isWrongNetwork = ref15.isWrongNetwork;
    var library = (0,_pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWeb3LibraryContext */ .Hp)();
    var toastError = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_44__/* .useToast */ .p)().toastError;
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return [
            currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped,
            currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped
        ];
    }, [
        currencyA,
        currencyB
    ]), tokenA = ref16[0], tokenB = ref16[1];
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$G)().t;
    var gasPrice = (0,_state_user_hooks__WEBPACK_IMPORTED_MODULE_34__/* .useGasPrice */ .Fh)();
    var canZapOut = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return zapSupportedChainId.includes(chainId) && zapMode;
    }, [
        chainId,
        zapMode
    ]);
    var zapModeStatus = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return canZapOut && !!zapMode && temporarilyZapMode;
    }, [
        canZapOut,
        zapMode,
        temporarilyZapMode
    ]);
    // burn state
    var ref17 = (0,_state_burn_hooks__WEBPACK_IMPORTED_MODULE_32__/* .useBurnState */ .Xi)(), independentField = ref17.independentField, typedValue = ref17.typedValue;
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), removalCheckedA = ref18[0], setRemovalCheckedA = ref18[1];
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), removalCheckedB = ref19[0], setRemovalCheckedB = ref19[1];
    var ref20 = (0,_state_burn_hooks__WEBPACK_IMPORTED_MODULE_32__/* .useDerivedBurnInfo */ .Vx)(currencyA !== null && currencyA !== void 0 ? currencyA : undefined, currencyB !== null && currencyB !== void 0 ? currencyB : undefined, removalCheckedA, removalCheckedB, zapModeStatus), pair = ref20.pair, parsedAmounts = ref20.parsedAmounts, error = ref20.error, tokenToReceive = ref20.tokenToReceive, estimateZapOutAmount = ref20.estimateZapOutAmount;
    var isZap = (!removalCheckedA || !removalCheckedB) && zapModeStatus;
    var poolData = (0,state_swap_hooks__WEBPACK_IMPORTED_MODULE_12__/* .useLPApr */ .aT)(pair);
    var ref21 = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_45__/* ["default"] */ .Z)(t("Based on last 7 days' performance. Does not account for impermanent loss"), {
        placement: "bottom"
    }), targetRef = ref21.targetRef, tooltip = ref21.tooltip, tooltipVisible = ref21.tooltipVisible;
    var ref22 = (0,_state_burn_hooks__WEBPACK_IMPORTED_MODULE_32__/* .useBurnActionHandlers */ .GF)(), _onUserInput = ref22.onUserInput;
    var isValid = !error;
    // modal and loading
    var ref23 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showDetailed = ref23[0], setShowDetailed = ref23[1];
    var ref24 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        attemptingTxn: false,
        liquidityErrorMessage: undefined,
        txHash: undefined
    }), ref25 = ref24[0], attemptingTxn = ref25.attemptingTxn, liquidityErrorMessage = ref25.liquidityErrorMessage, txHash = ref25.txHash, setLiquidityState = ref24[1];
    // txn values
    var deadline = (0,_hooks_useTransactionDeadline__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)();
    var ref26 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z)((0,_state_user_hooks__WEBPACK_IMPORTED_MODULE_34__/* .useUserSlippageTolerance */ .$2)(), 1), allowedSlippage = ref26[0];
    var ref27, ref28, ref29;
    var _obj;
    var formattedAmounts = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z)(_obj, _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT].equalTo("0") ? "0" : parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT].lessThan(new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .Percent */ .gG("1", "100")) ? "<1" : parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT].toFixed(0)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z)(_obj, _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY, independentField === _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY ? typedValue : (ref27 = (ref = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY]) === null || ref === void 0 ? void 0 : ref.toSignificant(6)) !== null && ref27 !== void 0 ? ref27 : ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z)(_obj, _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A, independentField === _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A ? typedValue : (ref28 = (ref1 = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)) !== null && ref28 !== void 0 ? ref28 : ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z)(_obj, _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B, independentField === _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B ? typedValue : (ref29 = (ref2 = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B]) === null || ref2 === void 0 ? void 0 : ref2.toSignificant(6)) !== null && ref29 !== void 0 ? ref29 : ""), _obj);
    var atMaxAmount = (ref3 = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT]) === null || ref3 === void 0 ? void 0 : ref3.equalTo(new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .Percent */ .gG("1"));
    // pair contract
    var pairContractRead = (0,_hooks_useContract__WEBPACK_IMPORTED_MODULE_23__/* .usePairContract */ .t0)(pair === null || pair === void 0 ? void 0 : (ref4 = pair.liquidityToken) === null || ref4 === void 0 ? void 0 : ref4.address, false);
    var pairContract = (0,_hooks_useContract__WEBPACK_IMPORTED_MODULE_23__/* .usePairContract */ .t0)(pair === null || pair === void 0 ? void 0 : (ref5 = pair.liquidityToken) === null || ref5 === void 0 ? void 0 : ref5.address);
    // allowance handling
    var ref30 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), signatureData = ref30[0], setSignatureData = ref30[1];
    var ref31 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z)((0,_hooks_useApproveCallback__WEBPACK_IMPORTED_MODULE_30__/* .useApproveCallback */ .qL)(parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY], isZap ? (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_8__/* .getZapAddress */ ._M)() : config_constants_exchange__WEBPACK_IMPORTED_MODULE_13__/* .ROUTER_ADDRESS */ .bR[chainId]), 2), approval = ref31[0], approveCallback = ref31[1];
    function onAttemptToApprove() {
        return _onAttemptToApprove.apply(this, arguments);
    }
    function _onAttemptToApprove() {
        _onAttemptToApprove = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_47__/* ["default"] */ .Z)(function() {
            var liquidityAmount, nonce, EIP712Domain, domain, Permit, message, data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_48__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!pairContract || !pairContractRead || !pair || !library || !deadline) throw new Error("missing dependencies");
                        liquidityAmount = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY];
                        if (!liquidityAmount) {
                            toastError(t("Error"), t("Missing liquidity amount"));
                            throw new Error("missing liquidity amount");
                        }
                        return [
                            4,
                            pairContractRead.nonces(account)
                        ];
                    case 1:
                        nonce = _state.sent();
                        EIP712Domain = [
                            {
                                name: "name",
                                type: "string"
                            },
                            {
                                name: "version",
                                type: "string"
                            },
                            {
                                name: "chainId",
                                type: "uint256"
                            },
                            {
                                name: "verifyingContract",
                                type: "address"
                            }
                        ];
                        domain = {
                            name: "Area51 (Alien Base) LP",
                            version: "1",
                            chainId: chainId,
                            verifyingContract: pair.liquidityToken.address
                        };
                        Permit = [
                            {
                                name: "owner",
                                type: "address"
                            },
                            {
                                name: "spender",
                                type: "address"
                            },
                            {
                                name: "value",
                                type: "uint256"
                            },
                            {
                                name: "nonce",
                                type: "uint256"
                            },
                            {
                                name: "deadline",
                                type: "uint256"
                            }
                        ];
                        message = {
                            owner: account,
                            spender: config_constants_exchange__WEBPACK_IMPORTED_MODULE_13__/* .ROUTER_ADDRESS */ .bR[chainId],
                            value: liquidityAmount.quotient.toString(),
                            nonce: nonce.toHexString(),
                            deadline: deadline.toNumber()
                        };
                        data = JSON.stringify({
                            types: {
                                EIP712Domain: EIP712Domain,
                                Permit: Permit
                            },
                            domain: domain,
                            primaryType: "Permit",
                            message: message
                        });
                        library.send("eth_signTypedData_v4", [
                            account,
                            data
                        ]).then(_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_49__.splitSignature).then(function(signature) {
                            setSignatureData({
                                v: signature.v,
                                r: signature.r,
                                s: signature.s,
                                deadline: deadline.toNumber()
                            });
                        }).catch(function(err) {
                            // for all errors other than 4001 (EIP-1193 user rejected request), fall back to manual approve
                            if ((err === null || err === void 0 ? void 0 : err.code) !== 4001) {
                                approveCallback();
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _onAttemptToApprove.apply(this, arguments);
    }
    // wrapped onUserInput to clear signatures
    var onUserInput = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(field, value) {
        setSignatureData(null);
        return _onUserInput(field, value);
    }, [
        _onUserInput
    ]);
    var onLiquidityInput = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(value) {
        return onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY, value);
    }, [
        onUserInput
    ]);
    var onCurrencyAInput = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(value) {
        return onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A, value);
    }, [
        onUserInput
    ]);
    var onCurrencyBInput = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(value) {
        return onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B, value);
    }, [
        onUserInput
    ]);
    var zapContract = (0,_hooks_useContract__WEBPACK_IMPORTED_MODULE_23__/* .useZapContract */ .n9)(true);
    // tx sending
    var addTransaction = (0,_state_transactions_hooks__WEBPACK_IMPORTED_MODULE_25__/* .useTransactionAdder */ .h7)();
    var routerContract = (0,_utils_exchange__WEBPACK_IMPORTED_MODULE_28__/* .useRouterContract */ .Ti)();
    function onZapOut() {
        return _onZapOut.apply(this, arguments);
    }
    function _onZapOut() {
        _onZapOut = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_47__/* ["default"] */ .Z)(function() {
            var liquidityAmount, totalTokenAmountOut, methodName, args;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_48__.__generator)(this, function(_state) {
                if (!chainId || !library || !account || !estimateZapOutAmount) throw new Error("missing dependencies");
                if (!zapContract) throw new Error("missing zap contract");
                if (!tokenToReceive) throw new Error("missing tokenToReceive");
                if (!currencyA || !currencyB) {
                    toastError(t("Error"), t("Missing tokens"));
                    throw new Error("missing tokens");
                }
                liquidityAmount = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY];
                if (!liquidityAmount) {
                    toastError(t("Error"), t("Missing liquidity amount"));
                    throw new Error("missing liquidity amount");
                }
                if (!tokenA || !tokenB) {
                    toastError(t("Error"), t("Could not wrap"));
                    throw new Error("could not wrap");
                }
                totalTokenAmountOut = removalCheckedA && !removalCheckedB ? parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A] : parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B];
                if (oneCurrencyIsNative && tokenToReceive.toLowerCase() === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .WNATIVE */ .FX[chainId].address.toLowerCase()) {
                    methodName = "zapOutETH";
                    args = [
                        pair.liquidityToken.address,
                        parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY].quotient.toString(),
                        (0,_utils_exchange__WEBPACK_IMPORTED_MODULE_28__/* .calculateSlippageAmount */ .uc)(estimateZapOutAmount, allowedSlippage)[0].toString(),
                        (0,_utils_exchange__WEBPACK_IMPORTED_MODULE_28__/* .calculateSlippageAmount */ .uc)(totalTokenAmountOut, allowedSlippage)[0].toString(), 
                    ];
                } else {
                    methodName = "zapOutToken";
                    args = [
                        pair.liquidityToken.address,
                        tokenToReceive,
                        parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY].quotient.toString(),
                        (0,_utils_exchange__WEBPACK_IMPORTED_MODULE_28__/* .calculateSlippageAmount */ .uc)(estimateZapOutAmount, allowedSlippage)[0].toString(),
                        (0,_utils_exchange__WEBPACK_IMPORTED_MODULE_28__/* .calculateSlippageAmount */ .uc)(totalTokenAmountOut, allowedSlippage)[0].toString(), 
                    ];
                }
                setLiquidityState({
                    attemptingTxn: true,
                    liquidityErrorMessage: undefined,
                    txHash: undefined
                });
                (0,utils_calls__WEBPACK_IMPORTED_MODULE_6__/* .callWithEstimateGas */ .Zj)(zapContract, methodName, args, {
                    gasPrice: gasPrice
                }).then(function(response) {
                    setLiquidityState({
                        attemptingTxn: false,
                        liquidityErrorMessage: undefined,
                        txHash: response.hash
                    });
                    var amount = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY].toSignificant(3);
                    var symbol = (0,utils_getLpSymbol__WEBPACK_IMPORTED_MODULE_50__/* .getLPSymbol */ .z)(pair.token0.symbol, pair.token1.symbol);
                    addTransaction(response, {
                        summary: "Remove ".concat(amount, " ").concat(symbol),
                        translatableSummary: {
                            text: "Remove %amount% %symbol%",
                            data: {
                                amount: amount,
                                symbol: symbol
                            }
                        },
                        type: "remove-liquidity"
                    });
                }).catch(function(err) {
                    if (err && err.code !== 4001) {
                        console.error("Remove Liquidity failed", err, args);
                    }
                    setLiquidityState({
                        attemptingTxn: false,
                        liquidityErrorMessage: err && (err === null || err === void 0 ? void 0 : err.code) !== 4001 ? "Remove Liquidity failed: ".concat(err.message) : undefined,
                        txHash: undefined
                    });
                });
                return [
                    2
                ];
            });
        });
        return _onZapOut.apply(this, arguments);
    }
    function onRemove() {
        return _onRemove.apply(this, arguments);
    }
    function _onRemove() {
        _onRemove = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_47__/* ["default"] */ .Z)(function() {
            var currencyAmountA, currencyAmountB, _obj, amountsMin, liquidityAmount, currencyBIsNative, oneCurrencyIsNative, methodNames, args, methodSafeGasEstimate, i, safeGasEstimate, _estimateGas, e, _routerContract, methodName, safeGasEstimate1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_48__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!chainId || !account || !deadline || !routerContract) throw new Error("missing dependencies");
                        currencyAmountA = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A], currencyAmountB = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B];
                        if (!currencyAmountA || !currencyAmountB) {
                            toastError(t("Error"), t("Missing currency amounts"));
                            throw new Error("missing currency amounts");
                        }
                        amountsMin = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z)(_obj, _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A, (0,_utils_exchange__WEBPACK_IMPORTED_MODULE_28__/* .calculateSlippageAmount */ .uc)(currencyAmountA, allowedSlippage)[0]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z)(_obj, _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B, (0,_utils_exchange__WEBPACK_IMPORTED_MODULE_28__/* .calculateSlippageAmount */ .uc)(currencyAmountB, allowedSlippage)[0]), _obj);
                        if (!currencyA || !currencyB) {
                            toastError(t("Error"), t("Missing tokens"));
                            throw new Error("missing tokens");
                        }
                        liquidityAmount = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY];
                        if (!liquidityAmount) {
                            toastError(t("Error"), t("Missing liquidity amount"));
                            throw new Error("missing liquidity amount");
                        }
                        currencyBIsNative = currencyB === null || currencyB === void 0 ? void 0 : currencyB.isNative;
                        oneCurrencyIsNative = (currencyA === null || currencyA === void 0 ? void 0 : currencyA.isNative) || currencyBIsNative;
                        if (!tokenA || !tokenB) {
                            toastError(t("Error"), t("Could not wrap"));
                            throw new Error("could not wrap");
                        }
                        // we have approval, use normal remove liquidity
                        if (approval === _hooks_useApproveCallback__WEBPACK_IMPORTED_MODULE_30__/* .ApprovalState.APPROVED */ .UK.APPROVED) {
                            // removeLiquidityETH
                            if (oneCurrencyIsNative) {
                                methodNames = [
                                    "removeLiquidityETH",
                                    "removeLiquidityETHSupportingFeeOnTransferTokens"
                                ];
                                args = [
                                    currencyBIsNative ? tokenA.address : tokenB.address,
                                    liquidityAmount.quotient.toString(),
                                    amountsMin[currencyBIsNative ? _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A : _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B].toString(),
                                    amountsMin[currencyBIsNative ? _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B : _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A].toString(),
                                    account,
                                    deadline.toHexString(), 
                                ];
                            } else {
                                methodNames = [
                                    "removeLiquidity"
                                ];
                                args = [
                                    tokenA.address,
                                    tokenB.address,
                                    liquidityAmount.quotient.toString(),
                                    amountsMin[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A].toString(),
                                    amountsMin[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B].toString(),
                                    account,
                                    deadline.toHexString(), 
                                ];
                            }
                        } else if (signatureData !== null) {
                            // removeLiquidityETHWithPermit
                            if (oneCurrencyIsNative) {
                                methodNames = [
                                    "removeLiquidityETHWithPermit",
                                    "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens"
                                ];
                                args = [
                                    currencyBIsNative ? tokenA.address : tokenB.address,
                                    liquidityAmount.quotient.toString(),
                                    amountsMin[currencyBIsNative ? _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A : _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B].toString(),
                                    amountsMin[currencyBIsNative ? _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B : _state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A].toString(),
                                    account,
                                    signatureData.deadline,
                                    false,
                                    signatureData.v,
                                    signatureData.r,
                                    signatureData.s, 
                                ];
                            } else {
                                methodNames = [
                                    "removeLiquidityWithPermit"
                                ];
                                args = [
                                    tokenA.address,
                                    tokenB.address,
                                    liquidityAmount.quotient.toString(),
                                    amountsMin[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A].toString(),
                                    amountsMin[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B].toString(),
                                    account,
                                    signatureData.deadline,
                                    false,
                                    signatureData.v,
                                    signatureData.r,
                                    signatureData.s, 
                                ];
                            }
                        } else {
                            toastError(t("Error"), t("Attempting to confirm without approval or a signature"));
                            throw new Error("Attempting to confirm without approval or a signature");
                        }
                        i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i < methodNames.length)) return [
                            3,
                            7
                        ];
                        safeGasEstimate = void 0;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (_estimateGas = routerContract.estimateGas)[methodNames[i]].apply(_estimateGas, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_51__/* ["default"] */ .Z)(args))
                        ];
                    case 3:
                        // eslint-disable-next-line no-await-in-loop
                        safeGasEstimate = _utils__WEBPACK_IMPORTED_MODULE_27__/* .calculateGasMargin.apply */ .yC.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        console.error("estimateGas failed", methodNames[i], args, e);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        if (_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_52__/* .BigNumber.isBigNumber */ .O$.isBigNumber(safeGasEstimate)) {
                            methodSafeGasEstimate = {
                                methodName: methodNames[i],
                                safeGasEstimate: safeGasEstimate
                            };
                            return [
                                3,
                                7
                            ];
                        }
                        _state.label = 6;
                    case 6:
                        i++;
                        return [
                            3,
                            1
                        ];
                    case 7:
                        if (!!methodSafeGasEstimate) return [
                            3,
                            8
                        ];
                        toastError(t("Error"), t("This transaction would fail"));
                        return [
                            3,
                            10
                        ];
                    case 8:
                        methodName = methodSafeGasEstimate.methodName, safeGasEstimate1 = methodSafeGasEstimate.safeGasEstimate;
                        setLiquidityState({
                            attemptingTxn: true,
                            liquidityErrorMessage: undefined,
                            txHash: undefined
                        });
                        return [
                            4,
                            (_routerContract = routerContract)[methodName].apply(_routerContract, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_51__/* ["default"] */ .Z)(args).concat([
                                {
                                    gasLimit: safeGasEstimate1
                                }
                            ])).then(function(response) {
                                var ref, ref1;
                                setLiquidityState({
                                    attemptingTxn: false,
                                    liquidityErrorMessage: undefined,
                                    txHash: response.hash
                                });
                                var amountA = (ref = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toSignificant(3);
                                var amountB = (ref1 = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(3);
                                addTransaction(response, {
                                    summary: "Remove ".concat(amountA, " ").concat(currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol, " and ").concat(amountB, " ").concat(currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol),
                                    translatableSummary: {
                                        text: "Remove %amountA% %symbolA% and %amountB% %symbolB%",
                                        data: {
                                            amountA: amountA,
                                            symbolA: currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol,
                                            amountB: amountB,
                                            symbolB: currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol
                                        }
                                    },
                                    type: "remove-liquidity"
                                });
                            }).catch(function(err) {
                                if (err && err.code !== 4001) {
                                    console.error("Remove Liquidity failed", err, args);
                                }
                                setLiquidityState({
                                    attemptingTxn: false,
                                    liquidityErrorMessage: err && (err === null || err === void 0 ? void 0 : err.code) !== 4001 ? t("Remove liquidity failed: %message%", {
                                        message: (0,utils_transactionErrorToUserReadableMessage__WEBPACK_IMPORTED_MODULE_53__/* .transactionErrorToUserReadableMessage */ .e)(err, t)
                                    }) : undefined,
                                    txHash: undefined
                                });
                            })
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return _onRemove.apply(this, arguments);
    }
    var ref32, ref33, ref34, ref35;
    var pendingText = t("Removing %amountA% %symbolA% and %amountB% %symbolB%", {
        amountA: (ref32 = (ref6 = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A]) === null || ref6 === void 0 ? void 0 : ref6.toSignificant(6)) !== null && ref32 !== void 0 ? ref32 : "",
        symbolA: (ref33 = currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol) !== null && ref33 !== void 0 ? ref33 : "",
        amountB: (ref34 = (ref7 = parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B]) === null || ref7 === void 0 ? void 0 : ref7.toSignificant(6)) !== null && ref34 !== void 0 ? ref34 : "",
        symbolB: (ref35 = currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol) !== null && ref35 !== void 0 ? ref35 : ""
    });
    var liquidityPercentChangeCallback = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(value) {
        onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, value.toString());
    }, [
        onUserInput
    ]);
    var oneCurrencyIsNative = (currencyA === null || currencyA === void 0 ? void 0 : currencyA.isNative) || (currencyB === null || currencyB === void 0 ? void 0 : currencyB.isNative);
    var oneCurrencyIsWNative = Boolean(chainId && (currencyA && ((ref8 = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .WNATIVE */ .FX[chainId]) === null || ref8 === void 0 ? void 0 : ref8.equals(currencyA)) || currencyB && ((ref9 = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .WNATIVE */ .FX[chainId]) === null || ref9 === void 0 ? void 0 : ref9.equals(currencyB))));
    var handleSelectCurrencyA = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(currency) {
        if (currencyIdB && (0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_54__/* .currencyId */ .H)(currency) === currencyIdB) {
            router.replace("/remove/".concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_54__/* .currencyId */ .H)(currency), "/").concat(currencyIdA), undefined, {
                shallow: true
            });
        } else {
            router.replace("/remove/".concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_54__/* .currencyId */ .H)(currency), "/").concat(currencyIdB), undefined, {
                shallow: true
            });
        }
    }, [
        currencyIdA,
        currencyIdB,
        router
    ]);
    var handleSelectCurrencyB = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(currency) {
        if (currencyIdA && (0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_54__/* .currencyId */ .H)(currency) === currencyIdA) {
            router.replace("/remove/".concat(currencyIdB, "/").concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_54__/* .currencyId */ .H)(currency)), undefined, {
                shallow: true
            });
        } else {
            router.replace("/remove/".concat(currencyIdA, "/").concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_54__/* .currencyId */ .H)(currency)), undefined, {
                shallow: true
            });
        }
    }, [
        currencyIdA,
        currencyIdB,
        router
    ]);
    var handleDismissConfirmation = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setSignatureData(null) // important that we clear signature data to avoid bad sigs
        ;
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, "0");
        }
    }, [
        onUserInput,
        txHash
    ]);
    var ref36 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z)((0,_hooks_useDebouncedChangeHandler__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(Number.parseInt(parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT].toFixed(0)), liquidityPercentChangeCallback), 2), innerLiquidityPercentage = ref36[0], setInnerLiquidityPercentage = ref36[1];
    var handleChangePercent = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(value) {
        return setInnerLiquidityPercentage(Math.ceil(value));
    }, [
        setInnerLiquidityPercentage
    ]);
    var ref37 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_55__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Swap_components_ConfirmRemoveLiquidityModal__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
        title: t("You will receive"),
        customOnDismiss: handleDismissConfirmation,
        attemptingTxn: attemptingTxn,
        hash: txHash || "",
        allowedSlippage: allowedSlippage,
        onRemove: isZap ? onZapOut : onRemove,
        isZap: isZap,
        pendingText: pendingText,
        approval: approval,
        signatureData: signatureData,
        tokenA: tokenA,
        tokenB: tokenB,
        liquidityErrorMessage: liquidityErrorMessage,
        parsedAmounts: parsedAmounts,
        currencyA: currencyA,
        currencyB: currencyB,
        toggleZapMode: setTemporarilyZapMode
    }), true, true, "removeLiquidityModal"), 1), onPresentRemoveLiquidity = ref37[0];
    var isZapOutA = isZap && !removalCheckedB && removalCheckedA;
    var isZapOutB = isZap && !removalCheckedA && removalCheckedB;
    var ref38, ref39, ref40, ref41;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Page__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_App__WEBPACK_IMPORTED_MODULE_17__/* .AppBody */ .j, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_App__WEBPACK_IMPORTED_MODULE_17__/* .AppHeader */ .t, {
                        backTo: "/liquidity",
                        title: t("Remove %assetA%-%assetB% liquidity", {
                            assetA: (ref38 = currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol) !== null && ref38 !== void 0 ? ref38 : "",
                            assetB: (ref39 = currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol) !== null && ref39 !== void 0 ? ref39 : ""
                        }),
                        subtitle: t("To receive %assetA% and %assetB%", {
                            assetA: (ref40 = currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol) !== null && ref40 !== void 0 ? ref40 : "",
                            assetB: (ref41 = currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol) !== null && ref41 !== void 0 ? ref41 : ""
                        }),
                        noConfig: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_56__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Layout_Column__WEBPACK_IMPORTED_MODULE_14__/* .AutoColumn */ .Tz, {
                                gap: "20px",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowBetween */ .m0, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                children: t("Amount")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIconButton, {
                                                        height: 32,
                                                        style: {
                                                            width: "100%"
                                                        },
                                                        isActive: !showDetailed,
                                                        side: "left",
                                                        variant: "text",
                                                        onClick: function() {
                                                            return setShowDetailed(false);
                                                        },
                                                        children: "Simple"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIconButton, {
                                                        height: 32,
                                                        width: "100%",
                                                        isActive: showDetailed,
                                                        side: "right",
                                                        variant: "text",
                                                        onClick: function() {
                                                            return setShowDetailed(true);
                                                        },
                                                        children: "Detailed"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !showDetailed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(BorderCard, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                className: "syncopate",
                                                textAlign: "center",
                                                fontSize: "32px",
                                                bold: true,
                                                mb: "16px",
                                                style: {
                                                    lineHeight: 1
                                                },
                                                children: [
                                                    formattedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT],
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_59__/* ["default"] */ .Z, {
                                                name: "lp-amount",
                                                min: 0,
                                                max: 100,
                                                value: innerLiquidityPercentage,
                                                onValueChanged: handleChangePercent,
                                                mb: "16px"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                width: "85%",
                                                m: "auto",
                                                flexWrap: "wrap",
                                                justifyContent: "space-evenly",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPercButton, {
                                                        onClick: function() {
                                                            return onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, "25");
                                                        },
                                                        children: "25%"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPercButton, {
                                                        onClick: function() {
                                                            return onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, "50");
                                                        },
                                                        children: "50%"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPercButton, {
                                                        onClick: function() {
                                                            return onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, "75");
                                                        },
                                                        children: "75%"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPercButton, {
                                                        onClick: function() {
                                                            return onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, "100");
                                                        },
                                                        children: t("Max")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !showDetailed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Layout_Column__WEBPACK_IMPORTED_MODULE_14__/* .ColumnCenter */ .lg, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_60__/* ["default"] */ .Z, {
                                            color: "textSubtle",
                                            width: "24px",
                                            my: "16px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Layout_Column__WEBPACK_IMPORTED_MODULE_14__/* .AutoColumn */ .Tz, {
                                        gap: "10px",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                bold: true,
                                                color: "textSubtle",
                                                fontSize: "14px",
                                                textTransform: "uppercase",
                                                children: t("Receive")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Card__WEBPACK_IMPORTED_MODULE_20__/* .LightGreyCard */ .m5, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                        justifyContent: "space-between",
                                                        mb: "8px",
                                                        as: "label",
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                                alignItems: "center",
                                                                children: [
                                                                    zapModeStatus && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                                        mr: "9px",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_61__/* ["default"] */ .Z, {
                                                                            disabled: isZapOutA,
                                                                            scale: "sm",
                                                                            checked: removalCheckedA,
                                                                            onChange: function(e) {
                                                                                return setRemovalCheckedA(e.target.checked);
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Logo__WEBPACK_IMPORTED_MODULE_21__/* .CurrencyLogo */ .Xw, {
                                                                        currency: currencyA
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                                        small: true,
                                                                        color: "textSubtle",
                                                                        id: "remove-liquidity-tokena-symbol",
                                                                        ml: "4px",
                                                                        children: currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                                        small: true,
                                                                        bold: true,
                                                                        children: formattedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A] || "0"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                                        small: true,
                                                                        ml: "4px",
                                                                        children: [
                                                                            "(",
                                                                            isZapOutA ? "100" : !isZap ? "50" : "0",
                                                                            "%)"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                        justifyContent: "space-between",
                                                        as: "label",
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                                alignItems: "center",
                                                                children: [
                                                                    zapModeStatus && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                                        mr: "9px",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_61__/* ["default"] */ .Z, {
                                                                            disabled: isZapOutB,
                                                                            scale: "sm",
                                                                            checked: removalCheckedB,
                                                                            onChange: function(e) {
                                                                                return setRemovalCheckedB(e.target.checked);
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Logo__WEBPACK_IMPORTED_MODULE_21__/* .CurrencyLogo */ .Xw, {
                                                                        currency: currencyB
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                                        small: true,
                                                                        color: "textSubtle",
                                                                        id: "remove-liquidity-tokenb-symbol",
                                                                        ml: "4px",
                                                                        children: currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                                        bold: true,
                                                                        small: true,
                                                                        children: formattedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B] || "0"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                                        small: true,
                                                                        ml: "4px",
                                                                        children: [
                                                                            "(",
                                                                            isZapOutB ? "100" : !isZap ? "50" : "0",
                                                                            "%)"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    chainId && (oneCurrencyIsWNative || oneCurrencyIsNative) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowBetween */ .m0, {
                                                        mt: "10px",
                                                        style: {
                                                            justifyContent: "flex-end",
                                                            fontSize: "14px"
                                                        },
                                                        children: oneCurrencyIsNative ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Links__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                            href: "/remove/".concat((currencyA === null || currencyA === void 0 ? void 0 : currencyA.isNative) ? (ref10 = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .WNATIVE */ .FX[chainId]) === null || ref10 === void 0 ? void 0 : ref10.address : currencyIdA, "/").concat((currencyB === null || currencyB === void 0 ? void 0 : currencyB.isNative) ? (ref11 = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .WNATIVE */ .FX[chainId]) === null || ref11 === void 0 ? void 0 : ref11.address : currencyIdB),
                                                            children: t("Receive %currency%", {
                                                                currency: (ref12 = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .WNATIVE */ .FX[chainId]) === null || ref12 === void 0 ? void 0 : ref12.symbol
                                                            })
                                                        }) : oneCurrencyIsWNative ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Links__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                            href: "/remove/".concat(currencyA && currencyA.equals(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .WNATIVE */ .FX[chainId]) ? native === null || native === void 0 ? void 0 : native.symbol : currencyIdA, "/").concat(currencyB && currencyB.equals(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .WNATIVE */ .FX[chainId]) ? native === null || native === void 0 ? void 0 : native.symbol : currencyIdB),
                                                            children: t("Receive %currency%", {
                                                                currency: native === null || native === void 0 ? void 0 : native.symbol
                                                            })
                                                        }) : null
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            showDetailed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_62__/* ["default"] */ .Z, {
                                my: "16px",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CurrencyInputPanel__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        value: formattedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY */ .g.LIQUIDITY],
                                        onUserInput: onLiquidityInput,
                                        onMax: function() {
                                            onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, "100");
                                        },
                                        // showMaxButton={!atMaxAmount}
                                        showMaxButton: true,
                                        disableCurrencySelect: true,
                                        currency: pair === null || pair === void 0 ? void 0 : pair.liquidityToken,
                                        pair: pair,
                                        id: "liquidity-amount",
                                        onCurrencySelect: function() {
                                            return null;
                                        },
                                        showCommonBases: true,
                                        commonBasesType: _components_SearchModal_types__WEBPACK_IMPORTED_MODULE_38__/* .CommonBasesType.LIQUIDITY */ .L0.LIQUIDITY
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Layout_Column__WEBPACK_IMPORTED_MODULE_14__/* .ColumnCenter */ .lg, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_60__/* ["default"] */ .Z, {
                                            width: "24px",
                                            my: "16px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CurrencyInputPanel__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        beforeButton: zapModeStatus && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_CurrencyInputPanel_ZapCheckbox__WEBPACK_IMPORTED_MODULE_9__/* .ZapCheckbox */ .y, {
                                            disabled: !removalCheckedB && removalCheckedA,
                                            checked: removalCheckedA,
                                            onChange: function(e) {
                                                setRemovalCheckedA(e.target.checked);
                                            }
                                        }),
                                        zapStyle: "zap",
                                        hideBalance: true,
                                        disabled: isZap && !removalCheckedA,
                                        value: formattedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A],
                                        onUserInput: onCurrencyAInput,
                                        onMax: function() {
                                            return onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, "100");
                                        },
                                        // showMaxButton={!atMaxAmount}
                                        showMaxButton: true,
                                        currency: currencyA,
                                        label: t("Output"),
                                        onCurrencySelect: handleSelectCurrencyA,
                                        id: "remove-liquidity-tokena",
                                        showCommonBases: true,
                                        commonBasesType: _components_SearchModal_types__WEBPACK_IMPORTED_MODULE_38__/* .CommonBasesType.LIQUIDITY */ .L0.LIQUIDITY
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Layout_Column__WEBPACK_IMPORTED_MODULE_14__/* .ColumnCenter */ .lg, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_63__/* ["default"] */ .Z, {
                                            width: "24px",
                                            my: "16px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CurrencyInputPanel__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        beforeButton: zapModeStatus && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_CurrencyInputPanel_ZapCheckbox__WEBPACK_IMPORTED_MODULE_9__/* .ZapCheckbox */ .y, {
                                            disabled: !removalCheckedA && removalCheckedB,
                                            checked: removalCheckedB,
                                            onChange: function(e) {
                                                setRemovalCheckedB(e.target.checked);
                                            }
                                        }),
                                        zapStyle: "zap",
                                        hideBalance: true,
                                        disabled: isZap && !removalCheckedB,
                                        value: formattedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B],
                                        onUserInput: onCurrencyBInput,
                                        onMax: function() {
                                            return onUserInput(_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, "100");
                                        },
                                        // showMaxButton={!atMaxAmount}
                                        showMaxButton: true,
                                        currency: currencyB,
                                        label: t("Output"),
                                        onCurrencySelect: handleSelectCurrencyB,
                                        id: "remove-liquidity-tokenb",
                                        showCommonBases: true,
                                        commonBasesType: _components_SearchModal_types__WEBPACK_IMPORTED_MODULE_38__/* .CommonBasesType.LIQUIDITY */ .L0.LIQUIDITY
                                    })
                                ]
                            }),
                            pair && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Layout_Column__WEBPACK_IMPORTED_MODULE_14__/* .AutoColumn */ .Tz, {
                                gap: "10px",
                                style: {
                                    marginTop: "16px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                        bold: true,
                                        color: "textSubtle",
                                        fontSize: "14px",
                                        textTransform: "uppercase",
                                        children: t("Prices")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Card__WEBPACK_IMPORTED_MODULE_20__/* .LightGreyCard */ .m5, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                justifyContent: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                        small: true,
                                                        color: "textSubtle",
                                                        children: [
                                                            "1 ",
                                                            currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol,
                                                            " ="
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                        small: true,
                                                        children: [
                                                            tokenA ? pair.priceOf(tokenA).toSignificant(6) : "-",
                                                            " ",
                                                            currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_58__/* ["default"] */ .Z, {
                                                justifyContent: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                        small: true,
                                                        color: "textSubtle",
                                                        children: [
                                                            "1 ",
                                                            currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol,
                                                            " ="
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                                        small: true,
                                                        children: [
                                                            tokenB ? pair.priceOf(tokenB).toSignificant(6) : "-",
                                                            " ",
                                                            currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(views_Swap_components_AdvancedSwapDetails__WEBPACK_IMPORTED_MODULE_39__/* .StyledRowBorders */ .S, {
                                showBorderBottom: true,
                                mt: "16px",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                        bold: true,
                                        color: "text",
                                        fontSize: "14px",
                                        children: t("Slippage Tolerance")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                        bold: true,
                                        color: "text",
                                        children: [
                                            allowedSlippage / 100,
                                            "%"
                                        ]
                                    })
                                ]
                            }),
                            poolData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(views_Swap_components_AdvancedSwapDetails__WEBPACK_IMPORTED_MODULE_39__/* .StyledRowBorders */ .S, {
                                showBorderBottom: true,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_64__/* ["default"] */ .Z, {
                                        ref: targetRef,
                                        bold: true,
                                        fontSize: "14px",
                                        color: "text",
                                        children: t("LP reward APR")
                                    }),
                                    tooltipVisible && tooltip,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_57__/* ["default"] */ .Z, {
                                        bold: true,
                                        color: "text",
                                        children: [
                                            (0,_utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_37__/* .formatAmount */ .d)(poolData.lpApr7d),
                                            "%"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_62__/* ["default"] */ .Z, {
                                position: "relative",
                                mt: "16px",
                                children: !account ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ConnectWalletButton__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    width: "100%"
                                }) : isWrongNetwork ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_CommitButton__WEBPACK_IMPORTED_MODULE_10__/* .CommitButton */ .A, {
                                    width: "100%"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowBetween */ .m0, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                                            variant: approval === _hooks_useApproveCallback__WEBPACK_IMPORTED_MODULE_30__/* .ApprovalState.APPROVED */ .UK.APPROVED || !isZap && signatureData !== null ? "success" : "primary",
                                            onClick: isZap ? approveCallback : onAttemptToApprove,
                                            disabled: approval !== _hooks_useApproveCallback__WEBPACK_IMPORTED_MODULE_30__/* .ApprovalState.NOT_APPROVED */ .UK.NOT_APPROVED || !isZap && signatureData !== null,
                                            width: "100%",
                                            mr: "0.5rem",
                                            children: approval === _hooks_useApproveCallback__WEBPACK_IMPORTED_MODULE_30__/* .ApprovalState.PENDING */ .UK.PENDING ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Loader_Dots__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                children: t("Enabling")
                                            }) : approval === _hooks_useApproveCallback__WEBPACK_IMPORTED_MODULE_30__/* .ApprovalState.APPROVED */ .UK.APPROVED || !isZap && signatureData !== null ? t("Enabled") : t("Enable")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                                            variant: !isValid && !!parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_A */ .g.CURRENCY_A] && !!parsedAmounts[_state_burn_actions__WEBPACK_IMPORTED_MODULE_33__/* .Field.CURRENCY_B */ .g.CURRENCY_B] ? "danger" : "primary",
                                            onClick: function() {
                                                setLiquidityState({
                                                    attemptingTxn: false,
                                                    liquidityErrorMessage: undefined,
                                                    txHash: undefined
                                                });
                                                onPresentRemoveLiquidity();
                                            },
                                            width: "100%",
                                            disabled: !isValid || !isZap && signatureData === null && approval !== _hooks_useApproveCallback__WEBPACK_IMPORTED_MODULE_30__/* .ApprovalState.APPROVED */ .UK.APPROVED || isZap && approval !== _hooks_useApproveCallback__WEBPACK_IMPORTED_MODULE_30__/* .ApprovalState.APPROVED */ .UK.APPROVED,
                                            children: error || t("Remove")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            pair ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Layout_Column__WEBPACK_IMPORTED_MODULE_14__/* .AutoColumn */ .Tz, {
                style: {
                    minWidth: "20rem",
                    width: "100%",
                    maxWidth: "400px",
                    marginTop: "1rem"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_PositionCard__WEBPACK_IMPORTED_MODULE_16__/* .MinimalPositionCard */ .WP, {
                    showUnwrapped: oneCurrencyIsWNative,
                    pair: pair
                })
            }) : null
        ]
    });
}


/***/ }),

/***/ 95549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96484);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52775);
/* harmony import */ var components_TransactionConfirmationModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51931);
/* harmony import */ var components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(941);
/* harmony import */ var components_Layout_Row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30445);
/* harmony import */ var state_burn_actions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54820);
/* harmony import */ var components_Logo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19259);
/* harmony import */ var hooks_useApproveCallback__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36585);
/* harmony import */ var _AddLiquidity_components_ZapErrorMessage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81135);











var ConfirmRemoveLiquidityModal = function(param) {
    var title = param.title, onDismiss = param.onDismiss, customOnDismiss = param.customOnDismiss, attemptingTxn = param.attemptingTxn, pair = param.pair, hash = param.hash, approval = param.approval, signatureData = param.signatureData, pendingText = param.pendingText, parsedAmounts = param.parsedAmounts, allowedSlippage = param.allowedSlippage, onRemove = param.onRemove, liquidityErrorMessage = param.liquidityErrorMessage, tokenA = param.tokenA, tokenB = param.tokenB, currencyA = param.currencyA, currencyB = param.currencyB, isZap = param.isZap, toggleZapMode = param.toggleZapMode;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var modalHeader = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
            gap: "md",
            children: [
                parsedAmounts[state_burn_actions__WEBPACK_IMPORTED_MODULE_6__/* .Field.CURRENCY_A */ .g.CURRENCY_A] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_5__/* .RowBetween */ .m0, {
                    align: "flex-end",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            fontSize: "24px",
                            children: (ref = parsedAmounts[state_burn_actions__WEBPACK_IMPORTED_MODULE_6__/* .Field.CURRENCY_A */ .g.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toSignificant(6)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_5__/* .RowFixed */ .DA, {
                            gap: "4px",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Logo__WEBPACK_IMPORTED_MODULE_7__/* .CurrencyLogo */ .Xw, {
                                    currency: currencyA,
                                    size: "24px"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    fontSize: "24px",
                                    ml: "10px",
                                    children: currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol
                                })
                            ]
                        })
                    ]
                }),
                parsedAmounts[state_burn_actions__WEBPACK_IMPORTED_MODULE_6__/* .Field.CURRENCY_A */ .g.CURRENCY_A] && parsedAmounts[state_burn_actions__WEBPACK_IMPORTED_MODULE_6__/* .Field.CURRENCY_B */ .g.CURRENCY_B] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_5__/* .RowFixed */ .DA, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        width: "16px"
                    })
                }),
                parsedAmounts[state_burn_actions__WEBPACK_IMPORTED_MODULE_6__/* .Field.CURRENCY_B */ .g.CURRENCY_B] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_5__/* .RowBetween */ .m0, {
                    align: "flex-end",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            fontSize: "24px",
                            children: (ref1 = parsedAmounts[state_burn_actions__WEBPACK_IMPORTED_MODULE_6__/* .Field.CURRENCY_B */ .g.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_5__/* .RowFixed */ .DA, {
                            gap: "4px",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Logo__WEBPACK_IMPORTED_MODULE_7__/* .CurrencyLogo */ .Xw, {
                                    currency: currencyB,
                                    size: "24px"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    fontSize: "24px",
                                    ml: "10px",
                                    children: currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    small: true,
                    textAlign: "left",
                    pt: "12px",
                    children: t("Output is estimated. If the price changes by more than %slippage%% your transaction will revert.", {
                        slippage: allowedSlippage / 100
                    })
                })
            ]
        });
    }, [
        allowedSlippage,
        currencyA,
        currencyB,
        parsedAmounts,
        t
    ]);
    var modalBottom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var ref;
        var ref1, ref2;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_5__/* .RowBetween */ .m0, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            children: t("%assetA%/%assetB% Burned", {
                                assetA: (ref1 = currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol) !== null && ref1 !== void 0 ? ref1 : "",
                                assetB: (ref2 = currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol) !== null && ref2 !== void 0 ? ref2 : ""
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_5__/* .RowFixed */ .DA, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Logo__WEBPACK_IMPORTED_MODULE_7__/* .DoubleCurrencyLogo */ .ge, {
                                    currency0: currencyA,
                                    currency1: currencyB,
                                    margin: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    children: (ref = parsedAmounts[state_burn_actions__WEBPACK_IMPORTED_MODULE_6__/* .Field.LIQUIDITY */ .g.LIQUIDITY]) === null || ref === void 0 ? void 0 : ref.toSignificant(6)
                                })
                            ]
                        })
                    ]
                }),
                pair && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_5__/* .RowBetween */ .m0, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    children: t("Price")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    children: [
                                        "1 ",
                                        currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol,
                                        " = ",
                                        tokenA ? pair.priceOf(tokenA).toSignificant(6) : "-",
                                        " ",
                                        currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_5__/* .RowBetween */ .m0, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    children: [
                                        "1 ",
                                        currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol,
                                        " = ",
                                        tokenB ? pair.priceOf(tokenB).toSignificant(6) : "-",
                                        " ",
                                        currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    width: "100%",
                    mt: "20px",
                    disabled: !(approval === hooks_useApproveCallback__WEBPACK_IMPORTED_MODULE_8__/* .ApprovalState.APPROVED */ .UK.APPROVED || signatureData !== null),
                    onClick: onRemove,
                    children: t("Confirm")
                })
            ]
        });
    }, [
        currencyA,
        currencyB,
        parsedAmounts,
        approval,
        onRemove,
        pair,
        tokenA,
        tokenB,
        t,
        signatureData
    ]);
    var confirmationContent = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return liquidityErrorMessage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                isZap && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddLiquidity_components_ZapErrorMessage__WEBPACK_IMPORTED_MODULE_9__/* .ZapErrorMessages */ .p, {
                    isSingleToken: true,
                    zapMode: isZap,
                    toggleZapMode: toggleZapMode,
                    onModalDismiss: onDismiss
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_TransactionConfirmationModal__WEBPACK_IMPORTED_MODULE_3__/* .TransactionErrorContent */ .ht, {
                    onDismiss: onDismiss,
                    message: liquidityErrorMessage
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_TransactionConfirmationModal__WEBPACK_IMPORTED_MODULE_3__/* .ConfirmationModalContent */ .pM, {
            topContent: modalHeader,
            bottomContent: modalBottom
        });
    }, [
        liquidityErrorMessage,
        isZap,
        toggleZapMode,
        onDismiss,
        modalHeader,
        modalBottom
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_TransactionConfirmationModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        title: title,
        onDismiss: onDismiss,
        customOnDismiss: customOnDismiss,
        attemptingTxn: attemptingTxn,
        hash: hash,
        // @ts-ignore
        content: confirmationContent,
        pendingText: pendingText
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConfirmRemoveLiquidityModal);


/***/ })

}]);